import { render, staticRenderFns } from "./DangerClassView.vue?vue&type=template&id=67bd1efa&"
import script from "./DangerClassView.vue?vue&type=script&lang=js&"
export * from "./DangerClassView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports